<div class="p-4 h-full rounded-lg flex flex-col">
  <div class="mb-4 space-y-4">
    <div>
      <div
        class="grid gap-3 gap-y-6"
        [style.grid-template-columns]="
          'repeat(' + columns + ', minmax(0, 1fr))'
        "
      >
        <div *ngFor="let rule of Rules" class="flex flex-col">
          <p
            class="text-center text-sm font-medium mb-1 text-gray-700 dark:text-neutral-400 overflow-hidden line-clamp-1 flex items-center justify-center gap-1"
            [title]="rule.context"
          >
            <span class="truncate">{{ rule.context }}</span>
            <i
              *ngIf="rule.latestMessage?.content"
              class="pi pi-info-circle text-blue-500 dark:text-blue-400 shrink-0 text-xs cursor-help"
              [pTooltip]="rule.latestMessage?.content"
              tooltipPosition="top"
            ></i>
          </p>
          <app-health-indicator-chart [rule]="rule" />
        </div>
      </div>
    </div>
  </div>
</div>
